import React from 'react';
import { connect } from 'react-redux';

import {
  FormFieldWithLabel,
} from 'views/FormComponents';

import {
  handlePostPurchaseDataUpdate,
  handleFileProtectionEmailVerify,
} from '../../actions/PostPurchaseActions';

const VerificationPage = ({
  handlePostPurchaseDataUpdate,
  handleFileProtectionEmailVerify,
  errors,
}) => (
  <div>
    <div className="caps font-rc soft--bottom">
      Digital File Protection
    </div>
    <div className="text-medium soft--bottom" style={{ lineHeight: '1.3em' }}>
      To prevent unauthorized digital downloads, please enter the email used during purchase to verify yourself.
    </div>
    <div>
      <form onSubmit={(e) => {
        e.preventDefault();
        handleFileProtectionEmailVerify();
      }}>
        <ul className="form-items-container">
          <FormFieldWithLabel
            label="Email Address"
            labelClassName="text-light-grey"
            errors={errors.emailAddressToVerify}>
            <input
              ref={input => input && input.focus()}
              type="text"
              onChange={(e) => handlePostPurchaseDataUpdate('emailAddressToVerify', e.target.value)}
              placeholder="username@domain.com"
            />
          </FormFieldWithLabel>
        </ul>
        <button
          className="btn btn-green btn-block">
          Verify
        </button>
      </form>
    </div>
  </div>
);

const VerificationSuccess = ({ emailAddressToVerify, tickImage }) => (
  <div>
    <div className="text-center">
      <img src={tickImage} />
      <h4 className="text-green font-rc push-half--top">Verification Successful</h4>
    </div>
    <div className="text-medium soft--ends text-center">
      A download link to the requested file has been mailed to {emailAddressToVerify}
    </div>
  </div>
);

const VerificationFailed = ({ handlePostPurchaseDataUpdate }) => (
  <div>
    <div className="text-center">
      <h3 className="text-red font-rc push-half--top">Verification Failed</h3>
    </div>
    <div className="text-medium soft--ends">
      The email you entered does not match with the buyer’s email.
    </div>
    <button
      className="btn btn-green btn-block push--top"
      onClick={() => {
        handlePostPurchaseDataUpdate('emailAddressToVerify', '');
        handlePostPurchaseDataUpdate('fileProtectionStatus', 'initial');
      }}
      >
      Retry
    </button>
  </div>
);

const DigitalFileProtection = ({
  fileProtectionStatus,
  emailAddressToVerify,
  tickImage,
  errors,
  handlePostPurchaseDataUpdate,
  handleFileProtectionEmailVerify,
}) => (
  <div className="soft">
    { fileProtectionStatus === 'initial' ?
      <VerificationPage
        handlePostPurchaseDataUpdate={(formField, formFieldData) => handlePostPurchaseDataUpdate(formField, formFieldData)}
        handleFileProtectionEmailVerify={() => handleFileProtectionEmailVerify()}
        errors={errors}
      /> : fileProtectionStatus === 'unlocked' ?
      <VerificationSuccess emailAddressToVerify={emailAddressToVerify}  tickImage={tickImage}/> :
      <VerificationFailed
        handlePostPurchaseDataUpdate={(formField, formFieldData) => handlePostPurchaseDataUpdate(formField, formFieldData)}
      />
    }
  </div>
);

const mapStateToProps = ({
  postPurchase: {
    fileProtectionStatus,
    emailAddressToVerify,
    tickImage,
    errors,
  },
}) => ({
  fileProtectionStatus,
  emailAddressToVerify,
  tickImage,
  errors,
});

export default connect(mapStateToProps, {
  handlePostPurchaseDataUpdate,
  handleFileProtectionEmailVerify,
})(DigitalFileProtection);



// WEBPACK FOOTER //
// ./src/payments/views/post-purchase/DigitalFileProtection.js